export const environment = {
  production: false,
  apiBaseUrl: 'https://localhost/atsapp',
  baseUrl: 'https://localhost'
};
